'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiThermometer = function TiThermometer(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm21.7 25.1v-9.3c0-0.4-0.4-0.8-0.9-0.8s-0.8 0.4-0.8 0.8v9.3c-1.4 0.4-2.5 1.7-2.5 3.2 0 1.9 1.5 3.4 3.3 3.4s3.4-1.5 3.4-3.4c0-1.5-1.1-2.8-2.5-3.2z m5-2.7v-13.2c0-3.3-2.6-5.9-5.9-5.9s-5.8 2.7-5.8 5.9v13.2c-1.5 1.5-2.5 3.6-2.5 5.9 0 4.6 3.7 8.4 8.3 8.4s8.4-3.8 8.4-8.4c0-2.3-1-4.4-2.5-5.9z m-5.9 10.9c-2.7 0-5-2.2-5-5 0-1.8 1-3.4 2.5-4.3v-14.8c0-1.4 1.2-2.5 2.5-2.5s2.5 1.1 2.5 2.5v14.8c1.5 0.9 2.5 2.5 2.5 4.3 0 2.8-2.2 5-5 5z' })
        )
    );
};

exports.default = TiThermometer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/thermometer.js
// module id = 2054
// module chunks = 0